import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

const GradientBanner = ({ 
  title, 
  description, 
  className = '', 
  path,
  backgroundIcons = [],
  button, // Add button prop
  onBackToSelectionClick,
  
}) => {
  const { t } = useTranslation();
  return (
    <div className={`max-xl:pl-4 bg-gradient-to-r from-midnigt to-shake pt-24 px-dynamic max-sm:h-56 max-md:h-64 h-72 ${className} relative overflow-hidden`}>
      
      {/* Animated background elements */}
      {backgroundIcons.length > 0 && (
        <div className="absolute inset-0 overflow-hidden">
          {[...Array(20)].map((_, i) => (
            <div
              key={i}
              className="absolute animate-float"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 5}s`,
                opacity: 0.1
              }}
            >
              <FontAwesomeIcon 
                icon={backgroundIcons[i % backgroundIcons.length]} 
                className="text-white text-4xl"
              />
            </div>
          ))}
        </div>
      )}

      {/* Content with animations */}
      <div className="relative z-10">
        {path && (
          <motion.div 
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="flex items-center gap-2 text-white/80 text-sm md:mb-12 max-xl:mt-8"
          >
            {path.map((item, index) => (
              <div key={index} className="flex items-center gap-2">
                {item.link ? (
                  <Link to={item.link} className="hover:text-white transition-colors">
                    {item.label}
                  </Link>
                ) :item.label === t('common.back') ? (
                  // For the "Back to Selection" breadcrumb, handle onClick
                  <span 
                    onClick={onBackToSelectionClick} 
                    className="cursor-pointer text-white underline hover:text-gray-200"
                  >
                    {item.label}
                  </span>
                ) : (
                  <span className="break-words">{item.label}</span>
                )}
                {index < path.length - 1 && <span>/</span>}
              </div>
            ))}
          </motion.div>
        )}
        
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <motion.h1 
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="text-h-5 max-xl:mt-2 max-sm:text-base font-bold text-white tracking-tight font-catamaran break-words"
          >
            {title}
          </motion.h1>
          
          <motion.p 
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="hidden md:block text-gray-200 text-nowrap mt-2 max-sm:text-sm text-body-big font-medium font-nunito-sans break-words"
          >
            {description}
          </motion.p>
        </motion.div>

        {/* Render the button if it's provided */}
        {button && (
          <div className="">
            {button}
          </div>
        )}
      </div>
    </div>
  );
};

export default GradientBanner;